module.exports = __webpack_public_path__ + "img/04_bohle.74d9af01.jpeg";